import RegularisationDetail from "./regularisationDetail";
export default RegularisationDetail